module.exports = __webpack_public_path__ + "static/img/装饰18.af48a41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰18.svg
// module id = fzrK
// module chunks = 2